import React, { Component }  from 'react';
import PropTypes from 'prop-types';
import { withT } from "~app/BundleProvider";

// import Logging from '~app/core/logging';
// const log = Logging.getLogger('app.components.googledrivefilesave');

class GoogleDriveFileSave extends Component {
  static propTypes = {
    handleSave: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    type: PropTypes.string.isRequired,
  }

  state = {
    fileName:'',
    showError: false,
  }

  handleChange = (e) => {
    this.setState({fileName: e.target.value});
  }

  handleSave = () => {
    let fname = this.state.fileName;
    // Remove extra spaces
    fname = fname.replace(/\s+/g,' ').trim();
    // Validate file name
    let validFilename = !/[^a-z0-9\s_.@()-]/i.test(fname);
    if(validFilename){
      this.setState({showError: false});
      let validExtension = /\.zip$/i.test(fname);
      // Add zip extension if it's missing
      if(!validExtension){
        fname += '.zip';
      }
      this.props.handleSave(fname);
    }
    else {
      // Notify the user of an invalid file name
      this.setState({showError: true});
    }
  }

  render() {
    const { t } = this.props;
    return (
      <div className="GoogleDriveFileSave">
        <h1 className="GoogleDriveFileSave__title">{t("choose-file-name")}</h1>
        <input className="GoogleDriveFileSave__input" onChange={this.handleChange}
          aria-label={t("file-name-input")}/>
        {this.state.showError && <div className="GoogleDriveFileSave__error">{t("invalid-file-name")}</div>}
        {this.props.type === 'drive' && <h3 className="GoogleDriveFileSave_note">{t("google-warning")}</h3>}
        <div className="GoogleDriveFileSave__button-group">
          <button className="GoogleDriveFileSave__button" onClick={this.handleSave} disabled={this.state.fileName.length === 0}>{t("ok")}</button>
          <button className="GoogleDriveFileSave__button" onClick={this.props.onCancel}>{t("cancel")}</button>
        </div>
      </div>
    );
  }
}

export default withT(GoogleDriveFileSave);



// WEBPACK FOOTER //
// ./src/pages/Main/menu/GoogleDriveFileSave.js